import { useState, useEffect } from "react";
import { Create, Typography } from "@pankod/refine-mui";
import { useForm } from "@pankod/refine-react-hook-form";
import { useNavigation } from "@pankod/refine-core";

import Fields from "./Fields";

import useAuth from "contexts/AuthContext";
import useLocales from "locales/useLocales";
import { allLangs } from "locales/config";
import axios from "utils/axios";
import { toast } from "react-toastify";
import { normalizeData, separatePrimitiveAndObjectFields } from "utils/utils";

export default function Comp({ routeName, parentName }) {
  const { currentLang, defaultLang } = useLocales();
  const auth = useAuth();
  const owner = auth.user?.id ? auth.user?.id : "";

  const {
    refineCore: { formLoading, queryResult },
    saveButtonProps,
    register,
    control,
    formState: { errors },
    getValues,
    setError,
    setValue,
    watch,
  } = useForm({
    refineCoreProps: {
      metaData: {
        populate: "deep,2",
        locale: defaultLang,
        fakeParam: currentLang.value,
      },
    },
  });

  const path = parentName ? `${parentName}/${routeName}` : `${routeName}`;
  const { push } = useNavigation();

  const handleCreate = async (e, values) => {
    e.preventDefault();

    //crea prima i record dei prezziari
    var prezziari_ids = [];
    //per ogni prezziario invio prima i treatments
    for (var prezziario of prezziari) {
      var treatment_ids = [];
      for (var treatment of prezziario.treatments) {
        if (treatment.name != "" && treatment.pricePerPerson >= 0) {
          const { data, status } = await axios.post("/api/treatments", {
            data: treatment,
          });
          if (status === 200) treatment_ids.push(normalizeData(data).id); //e colleziono gli id dei record creati
        }
      }
      //poi invio il prezziario
      if (prezziario.base_price > 0 && prezziario.tot_guests > 0) {
        const { data, status } = await axios.post("/api/prezziarios", {
          data: {
            tot_guests: prezziario.tot_guests,
            base_price: prezziario.base_price,
            breakfast_included: prezziario.breakfast_included,
            treatments: treatment_ids,
          },
        });
        if (status === 200) prezziari_ids.push(normalizeData(data).id);
      }
    }
    //register("prezziari");
    //setValue("prezziari", prezziari_ids); //non funziona in questo caso. la var di stato non si aggiorna subito

    //poi invio il rate-plan in tutte le lingue necessarie
    try {
      // create default language
      let { data } = await axios.post(`/api/${routeName}`, {
        data: { ...values, prezziari: prezziari_ids, owner: owner },
      });

      // separate primitives and arrays and objects
      let { primitives, arraysAndObjects } =
        separatePrimitiveAndObjectFields(values);

      // create all localizations
      for (let lang of allLangs) {
        if (lang.value != defaultLang) {
          try {
            let { data: newLang } = await axios.post(
              `/api/${routeName}/${data.data.id}/localizations`,
              {
                locale: lang.value,
                ...primitives,
                //prezziari: prezziari_ids,
              }
            );
          } catch (error) {
            console.log("Localization Error", error);
            toast.error("Something went wrong while creating localization");
          }
        }
      }
      // open the selected language entry
      //push(`/${path}/edit/${currentLangEntry.id}`, "_self");
      push(`/${path}`, "_self"); //redirect to list page
    } catch (error) {
      console.log("Create Error", error);
      toast.error("Something went wrong while creating entry");
    }
  };

  const emptyPrezziario = {
    tot_guests: 1,
    base_price: 0,
    breakfast_included: false,
    treatments: [{ name: "", pricePerPerson: "", disabled: false }],
  };
  const [prezziari, setPrezziari] = useState([emptyPrezziario]);
  //console.log(prezziari);

  return (
    <Create
      isLoading={formLoading}
      saveButtonProps={{ onClick: (e) => handleCreate(e, getValues()) }}
      title={<Typography variant="h5">Crea Piano tariffario</Typography>}
      headerButtons={() => {}}
    >
      <Fields
        register={register}
        control={control}
        errors={errors}
        getValues={getValues}
        setError={setError}
        setValue={setValue}
        watch={watch}
        disabled={false}
        prezziari={prezziari}
        setPrezziari={setPrezziari}
        emptyPrezziario={emptyPrezziario}
      />
    </Create>
  );
}
